import connectionTypes from '../../consts/connectionTypes';
import deviceTypes from '../../consts/device/deviceTypes';
import QUERY_PARAM_VALUES from '../../consts/route/queryParamValues';

const DEVICE_TYPE_MAP = {
    [QUERY_PARAM_VALUES.DEVICE_TYPE_ILUMA_I2]: deviceTypes.ILUMA_I2_CHARGER,
    [QUERY_PARAM_VALUES.DEVICE_TYPE_ILUMA_I5]: deviceTypes.ILUMA_I5_CHARGER,
};

const CONNECTION_TYPE_MAP = {
    [QUERY_PARAM_VALUES.CONNECTION_TYPE_WIFI]: connectionTypes.WIFI,
    [QUERY_PARAM_VALUES.CONNECTION_TYPE_CELLULAR]: connectionTypes.CELLULAR,
    [QUERY_PARAM_VALUES.CONNECTION_TYPE_SIDEWALK]: connectionTypes.SIDEWALK,
};

const QR_TYPE_MAP = {
    [QUERY_PARAM_VALUES.QR_TYPE_PACKAGING]: QUERY_PARAM_VALUES.QR_TYPE_PACKAGING,
    [QUERY_PARAM_VALUES.QR_TYPE_QSG]: QUERY_PARAM_VALUES.QR_TYPE_QSG,
    [QUERY_PARAM_VALUES.QR_TYPE_DEVICE_UI]: QUERY_PARAM_VALUES.QR_TYPE_DEVICE_UI,
};

const SOURCE_TYPE_MAP = {
    [QUERY_PARAM_VALUES.SOURCE_TYPE_QR]: QUERY_PARAM_VALUES.SOURCE_TYPE_QR,
};

export const mapDeviceType = (deviceType) => DEVICE_TYPE_MAP[deviceType];

export const mapConnectionType = (connectionType) => CONNECTION_TYPE_MAP[connectionType];

export const mapQrType = (qrType) => QR_TYPE_MAP[qrType];

export const mapSourceType = (source) => SOURCE_TYPE_MAP[source];
